//= require personalised-utils.js
// CUSTOM: personalised-bundle-ui-handlers.js

/**
 * This module manages UI updates for bundle selectio    // Replaced direct read of window.personalised.mode with getMode()
    const mode = window.personalised.utils.getMode();
    if (mode === window.personalised.config.modes.EDIT) {tate.
 * It provides a standardized updateUI function that updates UI elements
 * based on which products are already in the bundle.
 */
(function() {
  // Ensure namespace exists
  window.personalised = window.personalised || {};
  
  /**
   * Updates UI elements with data-variant-id attributes to reflect bundle state
   * - Disables buttons for items already in the bundle
   * - Updates button text and styling based on selection state
   */  function updateUI() {
    // Check if the DOM is available first
    if (!document || !document.querySelectorAll) return;
    
    // Check if state is initialized
    if (!window.personalised.validation.validateBundleLoaded()) return;
    
    const elements = document.querySelectorAll('[data-variant-id]');
    if (!elements || elements.length === 0) return;
      elements.forEach(el => {
      if (!el || !el.dataset) return;
      
      // Use normalization utilities for IDs
      const variantId = window.personalised.utils.normalizeShopifyId(el.dataset.variantId);
      const productId = window.personalised.utils.normalizeShopifyId(el.dataset.productId);
      const isAvailable = el.dataset.available !== 'false'; // Convert to boolean, default to true if not specified
      
      if (window.personalised?.debugMode) console.debug('[updateUI] Normalized IDs from DOM:', { 
        originalVariantId: el.dataset.variantId, 
        normalizedVariantId: variantId,
        originalProductId: el.dataset.productId, 
        normalizedProductId: productId
      });
      
      // Cache the button reference once per element to avoid duplicate DOM queries
      const btn = el.querySelector('button[data-add-to-pack]');
      
      // Only proceed if button exists and we have valid IDs
      if (btn && variantId !== null && productId !== null) {
        // Check at product level first, then at variant level as fallback
        const isVariantInBundle = window.personalised.bundle.isInBundle(variantId);
        const isProductInBundle = typeof window.personalised.bundle.isProductInBundle === 'function' ? 
          window.personalised.bundle.isProductInBundle(productId) : 
          isVariantInBundle; // Fallback to variant check if method doesn't exist
          
        if (window.personalised?.debugMode) console.debug('[updateUI] Bundle status check:', { 
          variantId, 
          productId, 
          isVariantInBundle, 
          isProductInBundle 
        });
        
        // Handle sold-out variants first
        if (!isAvailable) {
          if (el.classList) {
            el.classList.remove('already-in-bundle');
            el.classList.add('variant-sold-out');
          }          btn.disabled = true;          btn.textContent = window.personalised.config.uiLabels.soldOut;
          if (btn.classList) {
            btn.classList.remove('added');
            btn.classList.add('sold-out');
          }
        } 
        // Then handle bundle state for available variants
        else if (isVariantInBundle || isProductInBundle) {
          if (el.classList) {
            el.classList.add('already-in-bundle');
            el.classList.remove('variant-sold-out');
          }          btn.disabled = true;          btn.textContent = window.personalised.config.uiLabels.added;
          if (btn.classList) {
            btn.classList.add('added');
            btn.classList.remove('sold-out');
          }
        } else {
          if (el.classList) {
            el.classList.remove('already-in-bundle');
            el.classList.remove('variant-sold-out');
          }          btn.disabled = false;          btn.textContent = window.personalised.config.uiLabels.addToPack;
          if (btn.classList) {
            btn.classList.remove('added');
            btn.classList.remove('sold-out');
          }
        }
      }    });
  }
  
  // Define UI handlers object with minimal interface
  const uiHandlers = {
    // Reference the standardized function to maintain consistency
    updateUI,
    
    init: function() {
      // Register event listeners
      const eventBus = window.personalised.eventBus;
      if (eventBus) {
        // Note: Direct UI updates now replace the following events:
        // 'itemAdded', 'itemRemoved', 'frequencyChanged', 'stateReset'
        eventBus.on('bundleStateLoaded', updateUI);
      }

      // Initialize submit button handler in EDIT mode only
      const submitButton = document.querySelector('#personalised-submit-button');
      if (submitButton) {
        submitButton.addEventListener('click', handleBundleSubmit);
      }
    }
  };
    /**
   * Handles bundle submission in EDIT mode
   * This function is responsible for updating existing subscriptions through Recharge
   * It will only process submissions when in EDIT mode and emits success/error events
   * 
   * @param {Event} event - The submission event object
   * @returns {Promise<void>}
   * 
   * @fires bundleUpdateSuccess when bundle is successfully updated in Recharge
   * @fires bundleUpdateError if the update fails
   */
  /**
   * Handles bundle submission in EDIT mode
   * Updates existing subscriptions through Recharge and provides visual feedback
   * Only processes submissions in EDIT mode, ignoring other modes
   * 
   * @param {Event} event - The submission event object
   * @returns {Promise<void>}
   * 
   * @fires bundleUpdateSuccess when bundle is successfully updated in Recharge
   * @fires bundleUpdateError if the update fails
   */
  async function handleBundleSubmit(event) {
    event.preventDefault();

    const button = event.target.closest('#personalised-submit-button');
    if (!button) return;

    // Only proceed if we're in EDIT mode
    // Using getMode() to get current mode
    const mode = window.personalised.utils.getMode();
    if (mode !== window.personalised.config.modes.EDIT) return;

    // Update button state
    button.disabled = true;
    button.classList.add('loading');

    try {
      // Convert bundle to Recharge format and submit
      const bundleData = window.personalised.bundle.toRechargeFormat();
      await window.personalised.rechargeUtils.updateBundle();

      // Emit success event and show message
      window.personalised.eventBus.emit('bundleUpdateSuccess', {});

      // Redirect to account page after short delay
      setTimeout(() => {
        window.location.href = window.personalised.config.routes.account;
      }, 2000);
    } catch (err) {
      console.error('Bundle submit failed:', err);
      window.personalised.eventBus.emit('bundleUpdateError', {});
    } finally {
      button.disabled = false;
      button.classList.remove('loading');
    }
  }

  // Assign handleBundleSubmit to the uiHandlers object
  uiHandlers.handleBundleSubmit = handleBundleSubmit;

  // Expose UI handlers through window.personalised namespace
  window.personalised.uiHandlers = uiHandlers;
  
  // Make updateUI function available in standard location
  window.personalised.updateUI = updateUI;
})();
